import { z } from 'zod';

/** Строковые ключи состояний — как их отдаёт и ждёт бекенд. */
export const PersonMoodStateKeys = {
  bored: 'bored',
  normal: 'normal',
} as const;

export const PersonMoodState = {
  bored: PersonMoodStateKeys.bored,
  normal: PersonMoodStateKeys.normal,
} as const;

export type PersonMoodState =
  (typeof PersonMoodState)[keyof typeof PersonMoodState];

/**
 * `PersonMoodState.param` из Dart — он же `@JsonValue`, поэтому совпадает
 * с самим значением перечисления.
 */
export const PERSON_MOOD_STATE_PARAM: Record<PersonMoodState, string> = {
  bored: PersonMoodStateKeys.bored,
  normal: PersonMoodStateKeys.normal,
};

/** `PersonMoodState.scenarioActivated` — сценарий включён только у `bored`. */
export function personMoodStateScenarioActivated(
  state: PersonMoodState,
): boolean {
  return state === PersonMoodState.bored;
}

/** Текущее настроение аватара. */
export interface PersonMoodModel {
  readonly personSlug: string;
  readonly moodState: PersonMoodState;
}

/**
 * `person_slug` -> `personSlug`, поэтому объект проходит через `.transform()`.
 * Чужое значение `mood_state` роняет разбор — как `$enumDecode` в Dart.
 */
export const personMoodModelSchema = z
  .object({
    person_slug: z.string(),
    mood_state: z.enum(PersonMoodState),
  })
  .transform(
    (json): PersonMoodModel => ({
      personSlug: json.person_slug,
      moodState: json.mood_state,
    }),
  );

export function personMoodModelFromJson(json: unknown): PersonMoodModel {
  return personMoodModelSchema.parse(json);
}

export function personMoodModelToJson(
  model: PersonMoodModel,
): Record<string, unknown> {
  return {
    person_slug: model.personSlug,
    mood_state: PERSON_MOOD_STATE_PARAM[model.moodState],
  };
}
